import { CameraIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";

const HeaderButton = ({ Icon, onClickFunction, pageLink }) => {
  const buttonContent = (
    <button
      className="flex items-center justify-center
                 Xbg-neutral-100 rounded-md
                 hover:opacity-95 active:opacity-60
                "
      onClick={onClickFunction}
    >
      <Icon className="text-neutral-700 w-7 h-7" />
    </button>
  );

  return (
    <div>
      {pageLink ? (
        <Link to={{ pathname: pageLink }}>{buttonContent}</Link>
      ) : (
        buttonContent
      )}
    </div>
  );
};

const SquareIconNavButton = ({
  Icon,
  actionFunction,
  activeColor,
  disabled,
}) => {
  return (
    <button
      className={`flex items-center justify-center p-2 rounded-lg w-full md:w-auto select-none
                    bg-neutral-100 hover:bg-opacity-80 active:bg-opacity-100
                    ${activeColor}
                    ${disabled && "opacity-50 pointer-events-none"}
                   `}
      onClick={actionFunction}
      disabled={disabled}
    >
      <Icon className="h-8 w-8 text-neutral-700 stroke-2" />
    </button>
  );
};

const SquareIconUtilityButton = ({
  Icon,
  actionFunction,
  color,
  hoverColor,
  activeColor,
  iconSize = "h-6 w-6",
  disabled,
}) => {
  return (
    <div className="">
      <button
        className={`p-1 rounded-md select-none
                    bg-neutral-100 hover:bg-opacity-80 active:bg-opacity-100
                    ${color} ${hoverColor} ${activeColor}
                    ${disabled && "opacity-50 pointer-events-none"}
                   `}
        onClick={actionFunction}
        disabled={disabled}
      >
        <Icon className={`${iconSize} text-neutral-900`} />
      </button>
    </div>
  );
};

const SquareXButton = ({ actionFunction, iconSize = "h-6 w-6", disabled }) => {
  return (
    <button
      className={`p-1 rounded-md select-none
                  bg-neutral-400 hover:bg-opacity-80 active:bg-opacity-100 active:bg-red-400
                  ${disabled && "opacity-50 pointer-events-none"}
                 `}
      onClick={actionFunction}
      disabled={disabled}
    >
      <XMarkIcon className={`${iconSize} stroke-2 text-white`} />
    </button>
  );
};

const TextUtilityButton = ({
  prompt,
  actionFunction,
  color = "bg-neutral-100",
  hoverColor,
  activeColor,
  customFont = "text-xl font-medium text-neutral-700",
  customPadding = "px-3 py-2",
  customStyles,
  fullWidth = false,
  disabled = false,
}) => {
  return (
    <button
      className={`rounded-lg select-none 
                  hover:bg-opacity-80 active:bg-opacity-100
                  ${color} ${hoverColor} ${activeColor} 
                  ${customPadding} 
                  ${fullWidth && "w-full"}
                  ${disabled && "opacity-50 pointer-events-none"} 
                  ${customStyles}
                 `}
      onClick={actionFunction}
      disabled={disabled}
    >
      <p className={customFont}>{prompt}</p>
    </button>
  );
};

const TextActionButton = ({
  prompt,
  actionFunction,
  color = "bg-black",
  hoverColor,
  activeColor,
}) => {
  return (
    <button
      className={`flex items-center justify-center w-full md:w-auto 
                  px-4 py-3 rounded-lg select-none
                  hover:bg-opacity-80 active:bg-opacity-90
                  ${color} ${hoverColor} ${activeColor}
                 `}
      onClick={actionFunction}
    >
      <p className="text-3xl font-medium text-white">{prompt}</p>
    </button>
  );
};

const TextIconUtilityButton = ({
  Icon,
  prompt,
  iconSide,
  actionFunction,
  color,
  hoverColor,
  activeColor,
  pageLink,
}) => {
  const buttonContent = (
    <button
      className={`flex items-center justify-center w-full md:w-auto px-3 py-2 rounded-lg select-none
                  bg-neutral-100 hover:bg-opacity-80 active:bg-opacity-100
                  ${color} ${hoverColor} ${activeColor}
                 `}
      onClick={actionFunction}
    >
      <div
        className={`flex flex-row ${iconSide === "left" ? "flex-reverse" : ""}`}
      >
        <p className="text-2xl font-medium text-neutral-700">{prompt}</p>
        <div className="p-2" />
        <Icon className="h-8 w-8 text-neutral-700 stroke-2" />
      </div>
    </button>
  );

  return (
    <>
      {pageLink ? (
        <Link to={{ pathname: pageLink }} className="w-full md:w-auto">
          {buttonContent}
        </Link>
      ) : (
        buttonContent
      )}
    </>
  );
};

const DropzoneButton = ({ openFunction }) => {
  return (
    <button
      className="flex flex-col items-center justify-center p-10 rounded-2xl"
      onClick={openFunction}
    >
      <CameraIcon className="h-40 w-40 md:h-52 md:w-52 md:stroke-1 text-neutral-500 mb-2 md:mb-10" />

      <div className="text-4xl md:text-3xl font-medium text-center text-neutral-500 md:mb-7">
        {/* mb-7 is to align processing dropzone icons */}
        <p className="md:hidden">Take Photo</p>
        <p className="hidden md:flex">Take Photo or Drag & Drop</p>
      </div>
    </button>
  );
};

export {
  HeaderButton,
  SquareIconNavButton,
  SquareIconUtilityButton,
  SquareXButton,
  TextUtilityButton,
  TextActionButton,
  TextIconUtilityButton,
  DropzoneButton,
};
